var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.701 0L10 9.427V13h3.299L22 3.574 18.701 0zm-7.964 12.202v-2.01l1.855 2.01h-1.855zm2.403-.16l-2.256-2.444 6.15-6.664 2.257 2.445-6.15 6.664zm4.416-9.672L18.7 1.13l2.257 2.444-1.145 1.24-2.257-2.444z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18h15v-7.696h-.756v6.89H5.756V2.806h6.46V2H5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d03e430e9b1705de3416dbc8ce351dd0.svg";
export { ForwardRef as ReactComponent };